<template>
  <DialogHeader>
    <div
      class="font-primary tablet-h:font-medium tablet-h:text-[24px] tablet-h:leading-[28px] text-gray-900"
    >
      Potential infringement {{ number }}
    </div>
  </DialogHeader>
  <DialogContent>
    <MobileMatch
      :type="type"
      :match="match"
      :number="number"
      class="tablet-h:hidden"
    />
    <Match
      :type="type"
      :match="match"
      :number="number"
      class="hidden tablet-h:grid"
    />
  </DialogContent>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { MatchCategoryType } from '@/shared/graphql/router/graphql'
import type { FragmentType } from '@/shared/graphql/router/fragment-masking'
import Match, { MatchBreakdownFragment } from './Match.vue'
import MobileMatch from './MobileMatch.vue'

defineProps<{
  type: MatchCategoryType
  match: FragmentType<typeof MatchBreakdownFragment>
  number: number
}>()
</script>
